const receptionPointsTabs = () => {
  const receptionTabs = document.querySelectorAll('.reception-points__tab');

  if (!receptionTabs) {
    return;
  }

  const receptionPointsButtons = document.querySelectorAll('.reception-points__button');

  receptionPointsButtons.forEach((e) => {
    e.addEventListener('click', function () {
      let id = e.getAttribute('data-id');
      let tab = document.getElementById(id);
      let currentButton = document.querySelector('.reception-points__button--active');
      tab.classList.add('reception-points__tab--active');
      currentButton.classList.remove('reception-points__button--active');
      e.classList.add('reception-points__button--active');
      receptionTabs.forEach((i) => {
        if (i.id !== id) {
          i.classList.remove('reception-points__tab--active');
        }
      });
    });
  });
};

export {receptionPointsTabs};
